import React from "react";

const LogoIcon = ({ type = 'logo', style, title = ''}) => {
  const images = require.context("../../../assets/img/logos", true);
  try {
    let img = images(`./${type.toLowerCase()}.png`);
    console.log('img', img);
    return (
      <img style={style} alt={title} title={title} src={img} />
    );
  } catch (e) {
    return <></>;
  }
};

export default LogoIcon;
